import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_UPLOAD_COMPLETED_SCHEMA = Object.freeze({
  INPUT_ID: '',
  INPUT_LOCAL_ID: '',
  INPUT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_UPLOAD_COMPLETED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_UPLOAD_COMPLETED_SCHEMA);

export class UploadCompletedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.upload_completed;
  }

  get properties() {
    return this.toJS();
  }
}
